/**
 * What a push to a phone may say. A push passes through Expo, Apple or Google and shows on a lock
 * screen, so by default it says only what kind of thing waits; the app fetches the record when it
 * is opened. Administrators may let pushes carry the record's own words.
 */

import { useState } from 'react';

import { routes } from '../api/client.ts';
import { useLoad } from '../hooks.ts';
import { ErrorNote, ListBlock, ListGroup, ListRow, Toggle } from './ui.tsx';

export function PushSettingsPanel() {
  const settings = useLoad(() => routes.pushSettings().catch(() => undefined), []);
  const [error, setError] = useState<string>();
  const [saving, setSaving] = useState(false);
  // Only administrators can read it; for anyone else the panel is not shown.
  if (!settings.data) return null;
  const detail = settings.data.detail;
  const change = async (on: boolean) => {
    setError(undefined);
    setSaving(true);
    try {
      await routes.setPushSettings({ detail: on });
      settings.reload();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSaving(false);
    }
  };
  return (
    <ListGroup id="phone-notifications" title="Phone notifications" description="A notification passes through Apple or Google on its way to a phone, and shows on its lock screen.">
      <ListRow
        title="Show what the request says"
        description='Off, a phone shows only "Needs your approval" or "An agent finished", and the app loads the details when it is opened. On, the title and text of the request travel through Apple or Google and show on the lock screen.'
        control={<Toggle label="Show what the request says" checked={detail} isDisabled={saving} onChange={(v) => void change(v)} />}
      />
      {error ? (
        <ListBlock>
          <ErrorNote error={error} />
        </ListBlock>
      ) : null}
    </ListGroup>
  );
}
